module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.svg
// module id = 380
// module chunks = 0